
const pagesStyle = theme => ({
  wrapper: {
    height: "auto",
    minHeight: "100vh",
    position: "relative",
    top: "0"
  },
  fullPage: {
    padding: "120px 0",
    position: "relative",
    minHeight: "100vh",
    display: "flex!important",
    margin: "0",
    border: "0",
    color: "#fff",
    alignItems: "center",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      minHeight: "fit-content!important"
    },
    "& footer": {
      position: "absolute",
      bottom: "0",
      width: "100%",
      border: "none !important"
    },
    "&:before": {
      // background: "linear-gradient(170deg,rgba(30,0,0,.9),rgba(15,0,0,.8),rgba(0,0,0,.7)),url(https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/backgrounds%2FdotBG.gif?alt=media&token=bfd0dbca-1d59-4346-a317-ba8c4bdcda46)",
      backgroundColor: "black",
      opacity: ".7"
    },
    "&:before,&:after": {
      display: "block",
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0",
      left: "0",
      zIndex: "2"
    }
  }
});

export default pagesStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx